import * as React from 'react';
import { useChatsNotifications } from './hook';

interface IProps {
  children(props: { notificationsCount: number | null }): JSX.Element;
}

export function ChatsNotifications(props: IProps) {
  const notificationsCount = useChatsNotifications();

  return <>{props.children({ notificationsCount })}</>;
}
